export const Body = ({
                         children,
                     }) => {
    return <>{children}</>;
};

Body.dslType = "body";

export default Body;